import { ENERSI_VERSION } from "utils/variables";
import { PROYECT, api_post } from "services/api";

export const logMessageToService = async (message) => {
  const errorMessage = `
    [GN4 - ERROR B.] 
    [VERSION - ${ENERSI_VERSION}]
    -------------------------------------
    Fecha: ${new Date().toLocaleString()}
    -------------------------------------
    MODULO: ${window.location.pathname}
    -------------------------------------
    Tipo: Mensaje Custom
    -------------------------------------
    Mensaje: ${message}
    -------------------------------------
    `.trim();

  const url = `${process.env.REACT_APP_URL}${PROYECT}/logger/front/slack/critical`;
  api_post(url, {
    url: window.location.href,
    message: errorMessage,
  }).catch(e => console.error("Failed to log error to server", e));
}
